import { render } from "./PrivacyStatement.vue?vue&type=template&id=00715c4b&scoped=true&ts=true"
import script from "./PrivacyStatement.ts?vue&type=script&lang=ts&external"
export * from "./PrivacyStatement.ts?vue&type=script&lang=ts&external"

import "./PrivacyStatement.scss?vue&type=style&index=0&id=00715c4b&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00715c4b"]])

export default __exports__